export { avaleht };

const avaleht = () => {
    if (MODULE_NAME === "avaleht") {
        //MAP-TOGGLE
        $('.map-toggle').on('click', function () {
            var $opener = $('.map-content, .map-header'),
                $mapText = $('.map-toggle-text'),
                $mapHeader = $('.map-header'),
                isOpen = $mapHeader.hasClass('open');
            if (isOpen) {
                $opener.removeClass('open');
                $mapText.text('Ava');
                $mapHeader.find("i").removeClass("fa-angle-up").addClass("fa-angle-down");
                $.get("/map_state/0");
            } else {
                $opener.addClass('open');
                $mapText.text('Sulge');
                $mapHeader.find("i").removeClass("fa-angle-down").addClass("fa-angle-up");
                $.get("/map_state/1");
            }
    
        });
        //MATERIAL-TOGGLE
        $('.material-toggle').on('click', function () {
            var $opener = $('.material-content, .material-header'),
                $materialText = $('.material-toggle-text'),
                $materialHeader = $('.material-header'),
                isOpen = $materialHeader.hasClass('open');
            if (isOpen) {
                $opener.removeClass('open');
                $materialText.text('Ava');
                $materialHeader.find("i").removeClass("fa-angle-up").addClass("fa-angle-down");
                $.get("/material_state/0");
            } else {
                $opener.addClass('open');
                $materialText.text('Sulge');
                $materialHeader.find("i").removeClass("fa-angle-down").addClass("fa-angle-up");
                $.get("/material_state/1");
            }
    
        });
    }
}